import { useState, useEffect, useCallback } from 'react';

export function debounce(func: () => void, wait: number): () => void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let h: any;
  return (): void => {
    clearTimeout(h);
    h = setTimeout(() => func(), wait);
  };
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function useWindowDimensions(): { width: number; height: number } {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  const handleResize = useCallback((): void => {
    setWindowDimensions(getWindowDimensions());
  }, []);

  const debouncedUpdateWidth = debounce(handleResize, 200);

  useEffect(() => {
    window.addEventListener('resize', debouncedUpdateWidth);
    return (): void => {
      window.removeEventListener('resize', debouncedUpdateWidth);
    };
  }, [debouncedUpdateWidth, handleResize]);

  return windowDimensions;
}
